import styled from 'styled-components';

export default styled.div`
  background: var(--oxfordBlue-800);
  color: var(--white);
  height: 16px;
  border-radius: 5px;
  font-size: 12px;
  padding: 1px 4px;
  text-align: center;
  box-sizing: border-box;
`;
